export default "__VITE_ASSET__BOvUybuO__"